import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { createDraftCpd, getCpdChatId } from 'shared/actions/cpd';
import { useCpdTracking } from 'shared/containers/valuationTraps/utils/tracking/cpd';
import { selectFirstAnyPhone, selectOffer } from 'shared/selectors';
import { selectCpdDraftId, selectCpdDraftStatus } from 'shared/selectors/cpd/cpd';

export const useCPDProps = (isHomeowner?: boolean) => {
  const cpdDraftStatus = useSelector(selectCpdDraftStatus);
  const cpdDraftId = useSelector(selectCpdDraftId);
  const offer = useSelector(selectOffer);

  const userPhone = useSelector(selectFirstAnyPhone);

  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const [phoneValue, setPhoneValue] = React.useState(userPhone ?? null);

  const dispatch = useDispatch();

  const { trackCPDGoToChatClick, trackCPDTrapClick, trackCPDCreateDraftClick } = useCpdTracking(isHomeowner);

  const onPhoneInputChange = React.useCallback((value: string) => {
    setPhoneValue(value);
  }, []);

  const onTrapClick = React.useCallback(() => {
    setIsModalOpen(true);

    trackCPDTrapClick();
  }, []);

  const onCloseTrapModal = React.useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const onCreateDraftCpd = React.useCallback(async () => {
    trackCPDCreateDraftClick();
    await dispatch(
      createDraftCpd({
        phone: phoneValue,
        isHomeowner,
      }),
    );
  }, [dispatch, phoneValue]);

  const onGoCianChat = React.useCallback(
    async (draftId?: number) => {
      trackCPDGoToChatClick(draftId);

      const chatId = await dispatch(getCpdChatId());

      const url = chatId ? `https://www.cian.ru/dialogs/?chatId=${chatId}` : 'https://www.cian.ru/dialogs/?';
      window.open(url);
    },
    [dispatch],
  );

  return {
    isModalOpen,
    cpdDraftStatus,
    cpdDraftId,
    offer,
    phoneValue,
    onPhoneInputChange,
    onTrapClick,
    onCloseTrapModal,
    onCreateDraftCpd,
    onGoCianChat,
  };
};
